import {useMutation} from "@apollo/client";
import {EditIssueDocument, EditIssueInput} from "generated/graphql";

export const useEditIssue = () => {
  const [mutate] = useMutation(EditIssueDocument);

  return (input: EditIssueInput) => mutate({ variables: { input }});
}